import { configureStore } from '@reduxjs/toolkit';
import assessmentSlice from './assessment/assessmentSlice';
import questionSlice from './assessment/questionSlice';
import authSlice from './auth/authSlice';
import networkSlice from './network/networkSlice';
import toastSlice from './toast/toastSlice';
import userSlice from './user/userSlice';
import adaptiveAssessmentSlice from './adaptiveAssessment/adaptiveAssessmentSlice';
import timeSlice from './time/timeSlice';
import webRTCSlice from './aibotassessment/AIWebRTCSlice';
import * as Sentry from '@sentry/react';
import aiQuestionSlice from './aibotassessment/AIQuestionSlice';
import aiAssessmentSlice from './aibotassessment/AIBotAssessmentSlice';
import candidateActivitySlice from './CandidateActivity/CandidateActivitySlice';
import proctoringSlice from './proctoringProvider/proctoringProviderSlice';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  // Optionally pass options listed below
});

export const store = configureStore({
  reducer: {
    auth: authSlice,
    userInfo: userSlice,
    assessment: assessmentSlice,
    question: questionSlice,
    aiAssessment: aiAssessmentSlice,
    aiQuestion: aiQuestionSlice,
    toast: toastSlice,
    candidateActivity: candidateActivitySlice,
    network: networkSlice,
    adaptive: adaptiveAssessmentSlice,
    time: timeSlice,
    webRTC: webRTCSlice,
    proctoring: proctoringSlice,
  },
  enhancers: (getDefaultEnhancers: any) => {
    return getDefaultEnhancers.concat(sentryReduxEnhancer);
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
